import { Modal, ModalFuncProps } from 'antd';

const confirmModal = (onCallback: () => void, props?: ModalFuncProps) => {
  Modal.confirm({
    title: 'Atenção!',
    content: 'Foram feitas alterações no formulário, deseja realmente voltar?',
    okText: 'Sim',
    cancelText: 'Não',
    okType: 'primary',
    okButtonProps: { danger: true },
    onOk: onCallback,
    ...props,
  });
};

export default confirmModal;
